import type { MapIcon } from "@gettactic/api";
import type { ZoneTypeDefinition } from "@gettactic/map-builder/src/types";
import type { ToolKind } from "../types";
import { createAutoZoneTool } from "./autoZoneTool";
import { createDrawTool } from "./drawTool";
import { createGridTool } from "./gridTool";
import { createMeasureTool } from "./measureTool";
import { createStrokeTool } from "./numberingTool";
import { createPanTool } from "./panTool";
import {
  createFurnitureTool,
  createIconTool,
  createNodeStyleTool,
  createSpotTool,
  createTextTool
} from "./placeTools";
import { createStateAreaTool, createZonePolygonTool } from "./polygonTools";
import { createSelectTool } from "./selectTool";
import type { Tool } from "./Tool";
import { createWallPathTool } from "./wallPathTool";
import { createWallRectTool, createWallTool } from "./wallTool";

export interface ToolRegistryOptions {
  getZoneTag: () => ZoneTypeDefinition | null;
  /** Organisation icons (API-sourced), for the icon tool. */
  getMapIcons: () => MapIcon[];
  isRestrictedMode: () => boolean;
}

/** One instance per tool per editor; gesture-local state lives inside. */
export const createToolRegistry = (
  options: ToolRegistryOptions
): Record<ToolKind, Tool> => ({
  select: createSelectTool(),
  "draw-select": createStrokeTool("draw-select"),
  pan: createPanTool(),
  draw: createDrawTool("draw", options),
  numbering: createStrokeTool("numbering"),
  icon: createIconTool(options),
  furniture: createFurnitureTool(),
  spot: createSpotTool(options),
  text: createTextTool(),
  "node-style": createNodeStyleTool(),
  zone: createDrawTool("zone", options),
  wall: createWallTool(),
  "wall-rect": createWallRectTool(),
  "wall-path": createWallPathTool(),
  "state-area": createStateAreaTool(),
  "zone-polygon": createZonePolygonTool(),
  measure: createMeasureTool(),
  "auto-zone": createAutoZoneTool(),
  grid: createGridTool()
});
